import type { SupportedGame } from '@/config/supportedGames';
import { Game } from '@/constants/game.const';

export type Reward = {
  label: string;
  price?: string;
  imagePath: string;
};

export function getRewardsForGame(game: SupportedGame): Reward[] {
  switch (game) {
    case Game.CS2:
      return CS2_REWARDS;
    case Game.DOTA:
      return DOTA2_REWARDS;
    default:
      game satisfies never;
      throw new Error(`Unsupported game: ${game}`);
  }
}

export const CS2_REWARDS: Reward[] = [
  {
    label: 'AK-47 | Neon Rider (Field-Tested)',
    price: '$70',
    imagePath: '/rewards/cs2/1.png',
  },
  {
    label: 'AK-47 | Redline (Field-Tested)',
    price: '$40',
    imagePath: '/rewards/cs2/2.png',
  },
  {
    label: 'Desert Eagle | Conspiracy (Minimal Wear)',
    price: '$25',
    imagePath: '/rewards/cs2/3.png',
  },
  {
    label: 'AWP | Atheris (Minimal Wear)',
    price: '$12',
    imagePath: '/rewards/cs2/4.png',
  },
  {
    label: 'Chroma 2 Case',
    price: '$6',
    imagePath: '/rewards/cs2/5.png',
  },
];

export const DOTA2_REWARDS: Reward[] = [
  {
    label: "Flockheart's Gamble (Ogre Magi)",
    price: '$32',
    imagePath: '/rewards/dota2/1.png',
  },
  {
    label: 'Fractal Horns of Inner (Terroblade)',
    price: '$30',
    imagePath: '/rewards/dota2/2.png',
  },
  {
    label: 'Manifold Paradox (Phantom Assassin)',
    price: '$25',
    imagePath: '/rewards/dota2/3.png',
  },
  {
    label: 'Exalted The Magus Cypher (Rubick)',
    price: '$25',
    imagePath: '/rewards/dota2/4.png',
  },
  {
    label: 'Arms of Desolation',
    price: '$10',
    imagePath: '/rewards/dota2/5.png',
  },
];
